import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../Config";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const validateEmail = (email) => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };

  const handleLogin = async () => {
    setError("");

    if (!email || !password) {
      setError("Please fill in both fields.");
      return;
    }

    if (!validateEmail(email)) {
      setError("Invalid email format.");
      return;
    }

    try {
      const payload = {
        email: email,
        password: password,
      };

      const response = await fetch(`${BASE_URL}/userLogin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      const userRole = data?.data?.user?.id;

      // Store user role in session storage
      sessionStorage.setItem("userRole", userRole);

      // Redirect based on role
      if (userRole === 3) {
        navigate("/review-list-of-spot-registration");
      } else if (userRole === 5) {
        navigate("/express-entry/badge-print");
      } else if (userRole === 7) {
        navigate("/express-entry/badge-reassigned");
      } else if (userRole === 8) {
        navigate("/express-entry/separate-activity/0");
      } else if (userRole === 9) {
        navigate("/express-entry/check-in");
      } else if (userRole === 10) {
        navigate("/dashboard/activitiest");
      } else {
        setError("Invalid email or password");
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("Login failed. Please check your credentials and try again.");
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <label style={styles.label}>User Name</label>
        <input
          type="text"
          placeholder="Enter User Name"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={styles.input}
        />

        <label style={styles.label}>Password</label>
        <input
          type="password"
          placeholder="Enter Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={styles.input}
        />

        {error && <div style={styles.error}>{error}</div>}

        <div style={styles.buttonContainer}>
          <button style={styles.button} onClick={handleLogin}>
            LOGIN
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#f5f5f5",
    height: "70vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    backgroundColor: "#fff",
    padding: "30px",
    borderRadius: "6px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
    width: "600px",
  },
  label: {
    display: "block",
    marginBottom: "2px",
    fontWeight: "bold",
    fontSize: "16px",
  },
  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "20px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    fontSize: "16px",
  },
  error: {
    color: "red",
    marginBottom: "15px",
    fontWeight: "bold",
  },
  buttonContainer: {
    textAlign: "right",
  },
  button: {
    backgroundColor: "#fbc300",
    color: "#000",
    padding: "10px 25px",
    border: "none",
    borderRadius: "25px",
    fontWeight: "bold",
    fontSize: "14px",
    cursor: "pointer",
  },
};

export default Login;
